import { filter } from 'rxjs/operators';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { ApplicationDetailsModel } from 'src/app/models/farmers-application.model';
import { DashboardService } from 'src/app/services/dashboard.service';
import { FarmersApplicationService } from 'src/app/services/farmers-application.service';
import { OnFarmMiService } from 'src/app/services/on-farm-mi.service';
import { DomSanitizer } from '@angular/platform-browser';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { JEService } from 'src/app/services/je-services.service';
import { ChallanService } from 'src/app/services/challan-services.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';

@Component({
  selector: 'app-vendor-consent-form',
  templateUrl: './vendor-consent-form.component.html',
  styleUrls: ['./vendor-consent-form.component.scss'],
})
export class VendorConsentFormComponent implements OnInit {
  userId: any;
  autoId: any;
  appDetails: any;
  public sanctionLetterData: any;
  public appId: any;
  public progID: any;
  public sanctionLetterDataForTable: any[];
  miDetails: any;
  PondVerData: any;
  PondVerDataStage2: any;
  calculatedSubsidyDataForMIPhys: any;
  preEstimateDetails: any;
  physicalSurveyDetails: any;

  optionsPreEstimate: any;
  overlaysPreEstimate: any[];
  showMapPreEstimate: any;

  optionsJE: any;
  overlaysJE: any[];
  showMapJE: any;

  optionsXEN: any;
  overlaysXEN: any[];
  showMapXEN: any;

  miSurveyMapoptions: any;
  miSurveyoverlays: any[];
  miSurveyXENMapoptions: any;
  miSurveyXENoverlays: any[];

  applicationDetails: ApplicationDetailsModel = new ApplicationDetailsModel();
  applicationStatus: any;
  vendorApplicationDetails: any;
  // farmerDetails: any;

  farmerId: any;
  farmerData2: any;
  displayFileDialog: boolean;
  state: string = 'default';
  rotatableFilePath: any;
  public totalArea = 0;
  displayCustom: boolean;
  activeIndex: number = 0;
  items: any[];
  selectedStatus: any;
  remarks: String;
  //appId: String;
  vendorId: any;
  programId: any;
  isActionSectionEnabled: boolean;

  public isProDataCalculated: boolean = false;
  public proCalculatedData: any;
  public statusCode: any;
  public isPrintClicked: boolean = false;
  public userID: any;
  public cropType: any;
  public selectedCropType: any;
  public selectedCrop: any;

  public totalLandArea: number = 0;
  public existingMIDetails: any;

  //for multiple datasets
  public preEstimationDataArray: any = [];
  public miEstimationDataArray: any = [];
  public miBOQDataArray: any = [];
  public physicalSurveyDataArray: any = [];
  public sanctionLetterDataArray: any = [];
  public physicalSurveyDetailsArray: any = [];

  constructor(
    private route: ActivatedRoute,
    private _dashboardService: DashboardService,
    private ofService: OnFarmMiService,
    private messageService: MessageService,
    private farmerAppSer: FarmersApplicationService,
    private sanitizer: DomSanitizer,
    private deptDashBoardService: DepartmentDashboardService,
    private vendorService: VendorDashboardService,
    private router: Router,
    private cryptoJsService: CryptoJsService,
    private challanMIService: ChallanService,
    private jeService: JEService,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService
  ) {}

  ngOnInit() {
    this.getCropMaster();

    this.appId = this.route.snapshot.paramMap.get('appId');

    if (!this.appId) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Data Error : Cannot Load Form Due to Missing Application Id.',
      });
      return;
    }
    // this.vendorId = this.route.snapshot.paramMap.get('vendorId');
    // this.programId = this.route.snapshot.paramMap.get('programId');
    // this.autoId = this.route.snapshot.paramMap.get('autoId');
    // this.userId = this.route.snapshot.paramMap.get('userId');

    let farmerData = JSON.parse(window.sessionStorage.getItem('farmerDetails'));
    this.farmerData2 = farmerData;
    this.farmerId = farmerData?.Farmer_ID;

    if (this.appId) {
      this.getApplicationDetails(this.appId);
      this.getExistingMIDetails(this.appId);
      this.getApplicationStatus(this.appId);
      this.getPondVerDataSatge1(this.appId);
      this.getPondVerDataSatge2(this.appId);
    }
  }

  getCropMaster() {
    // this.loader.start();
    this.vendorService
      .getCropMaster()
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.cropType = res;
          // this.loader.close();
        },
        error: () => {
          // this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Crop Master not loaded.',
          });
        },
      });
  }

  onClickApp() {
    let statusCodeEncrypted = this.cryptoJsService.Encrypt(this.statusCode);
    const link = this.router.serializeUrl(
      this.router.createUrlTree(
        [
          'department',
          'print',
          this.appId,
          this.vendorId,
          this.programId,
          this.userId,
          this.autoId,
        ],
        { queryParams: { statusCode: statusCodeEncrypted } }
      )
    );
    window.open(link, '_blank');
  }

  getApplicationDetails(appId) {
    this.loader.start();
    this._dashboardService.getApplicationByAppId(appId).subscribe((res) => {
      this.loader.close();
      if (res) {
        this.applicationDetails = res;

        // res.ListViewFormData = [
        //   {
        //     "AutoId": 372819,
        //     "ProgId": 2,
        //     "VendorId": "302",
        //     "User_ID": "farmer"
        //   },
        //   {
        //     "AutoId": 372819,
        //     "ProgId": 2,
        //     "VendorId": "302",
        //     "User_ID": "farmer"
        //   }
        // ]

        if (res.ListViewFormData && res.ListViewFormData.length > 0) {
          res.ListViewFormData.forEach((val) => {
            let autoId = val?.AutoId;
            let progId = val?.ProgId;
            let userId = val?.User_ID;
            let vendorId = val?.VendorId;

            if (autoId!=null && userId!=null) {
              this.getCalculatedSubsidyDataForMIPhys(autoId, userId);
            }

            if (autoId!=null && progId!=null) {
              this.getPreEstimationData(this.appId, progId);
            }

            if (this.appId!=null && progId!=null) {
              this.getSanctionLetterData(this.appId, progId);
            }

            if (vendorId!=null && progId!=null) {
              this.getMIEstimationData(this.appId, vendorId, progId);
              this.getMIBOQData(this.appId, vendorId, progId);
            }

            if (autoId!=null && userId!=null) {
              this.getPhysicalSurveyData(autoId, userId);
            }
          });
        }

        if (
          this.applicationDetails.FarmerLand &&
          this.applicationDetails.FarmerLand.length > 0
        ) {
          this.applicationDetails.FarmerLand.forEach(
            (val) => (this.totalLandArea += parseFloat(val.totalArea))
          );
        }

        this.totalArea = 0;
        if (this.applicationDetails?.New_MI_Datas.length > 0) {
          this.applicationDetails.New_MI_Datas.forEach(
            (val) => (this.totalArea += parseFloat(val.totalArea))
          );
        }
        let farmerId = res.Farmer_ID;
        // if (res?.GroupTableData) {
        //   this.getPastSubsidiesByMultipleFarmerIds(res?.GroupTableData);
        // } else {
        //   this.getPastSubsidiesByFarmerId(farmerId);
        // }
      }
    });
  }

  getExistingMIDetails(appId){
    this._dashboardService.getExistingMIDetails(appId).subscribe((res) =>{
      this.existingMIDetails = res;
    })
  }

  getApplicationStatus(appId) {
    // this.loader.start();
    this._dashboardService
      .getApplicationStatusByAppId(appId)
      .subscribe((res) => {
        // this.loader.close();
        if (res) {
          this.applicationStatus = res.replace('Application Status: ', '');
        }
      });
  }

  getPondVerDataSatge1(appId) {
    this.jeService
      .getPondVerDataByAppIdStage1(appId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          console.log('Response Data', data);
          this.PondVerData = data;
          sessionStorage.setItem('pondData', JSON.stringify(data));
        },
        error: () => {
          // this.loader.close();
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: 'Data error! Dashboard not loaded.',
          // });
        },
      });
  }

  getPondVerDataSatge2(appId) {
    this.jeService
      .getPondVerDataByAppIdStage2(appId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          if(data?.PondStage2Status == 1){
            this.PondVerDataStage2 = data;
          }
        },
        error: () => {
          // this.loader.close();
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: 'Data error! Dashboard not loaded.',
          // });
        },
      });
  }

  onPrint(divName) {
    // var printContents = document.getElementById(divName).innerHTML;
    // var originalContents = document.body.innerHTML;
    // document.body.innerHTML = printContents;
    // window.print();
    // document.body.innerHTML = originalContents;
    document.body.style.visibility = 'hidden';
    document.getElementById(divName).style.visibility = 'visible';
    window.print();
    document.body.style.visibility = 'visible';
  }

  public viewWorkFlowAllStatus: boolean = false;
  workFlowAllStatus() {
    this.viewWorkFlowAllStatus = true;
    // <app-workFlowAllStatus></app-workFlowAllStatus>
    // this.router.navigate([
    //   `dashboard/${this.route.snapshot.paramMap.get(
    //     'appId'
    //   )}`,
    // ]);
  }

  openFileDialog(filePath) {
    this.rotatableFilePath = filePath;
    this.displayFileDialog = true;
  }

  getSafeUrl() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      this.rotatableFilePath
    );
  }

  onCloseDialog() {
    this.displayFileDialog = false;
  }

  @ViewChild('myname') myname: ElementRef;
  rotationAmount = 0;
  scalingAmount = 1;
  transformImage(direction, scale) {
    if (direction) {
      this.rotationAmount += direction == 'left' ? -90 : 90;
    }
    if (scale) {
      this.scalingAmount += scale == 'zoom-out' ? -0.1 : 0.1;
    }
    this.myname.nativeElement.style.transform = `rotate(${this.rotationAmount}deg) scale(${this.scalingAmount})`;
  }

  numberEquals(num1, num2) {
    return Number(num1) == Number(num2);
  }

  // onPrintSanctionLetter(divName) {
  //   this.isPrintClicked = true;
  //   var printContents = document.getElementById(divName).innerHTML;
  //   var originalContents = document.body.innerHTML;
  //   document.body.innerHTML = printContents;
  //   window.print();
  //   document.body.innerHTML = originalContents;
  // }

  imageClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }

  //pre-estimation
  getPreEstimationData(appId, programId) {
    if (appId && programId) {
      this.deptDashBoardService
        .getApplicationDataOfPreEstimation(appId, programId)
        .pipe(first())
        .subscribe({
          next: (data) => {
            this.preEstimateDetails = data;

            if (
              this.preEstimateDetails.CropTypeID &&
              this.preEstimateDetails.CropId
            ) {
              this.cropType.forEach((res) => {
                if (res.data === data.CropTypeID) {
                  // this.selectedCropType = res.label;
                  let crop = res.children;
                  crop.forEach((res2) => {
                    if (res2.data === data.CropId) {
                      this.preEstimateDetails = {
                        ...data,
                        selectedCropType: res?.label,
                        selectedCrop: res2.label,
                      };
                      // this.selectedCrop = res2.label;
                    }
                  });
                  return;
                }
              });
            }

            if (this.preEstimateDetails.listGPSCoordinates.length > 0) {
              this.showMapPreEstimate = true;
              let locationArray = [];
              this.preEstimateDetails.listGPSCoordinates.forEach((e) => {
                locationArray.push({ lat: e.Latitude, lng: e.Longitude });
              });
              this.optionsPreEstimate = {
                center: {
                  lat: locationArray[0].lat,
                  lng: locationArray[0].lng,
                },
                zoom: 17,
                mapTypeId: google.maps.MapTypeId.SATELLITE,
              };
              let pointLocations = [];
              locationArray.forEach((e) => {
                pointLocations.push(
                  new google.maps.Marker({
                    position: { lat: e.lat, lng: e.lng },
                  })
                );
              });
              this.overlaysPreEstimate = [
                ...pointLocations,
                new google.maps.Polygon({
                  paths: [...locationArray],
                  strokeOpacity: 0.5,
                  strokeWeight: 1,
                  fillColor: '#1976D2',
                  fillOpacity: 0.35,
                }),
              ];

              this.preEstimateDetails = {
                ...this.preEstimateDetails,
                overlaysPreEstimate: this.overlaysPreEstimate,
                optionsPreEstimate: this.optionsPreEstimate,
              };
            } else {
              this.showMapPreEstimate = false;
            }

            this.preEstimationDataArray.push(this.preEstimateDetails);
          },
          error: () => {},
        });
    }
  }

  getMIEstimationData(appId, vendorId, programId) {
    if (appId && vendorId && programId) {
      this.deptDashBoardService
        .getVendorMIEstimation(this.appId, vendorId, programId)
        .pipe(first())
        .subscribe({
          next: (data) => {
            if (data?.CropTypeID && data?.CropID) {
              this.cropType.forEach((res) => {
                if (res.data === data.CropTypeID) {
                  // this.selectedCropType = res.label;
                  let crop = res.children;
                  crop.forEach((res2) => {
                    if (res2.data === data.CropID) {
                      data = {
                        ...data,
                        selectedCropType: res?.label,
                        selectedCrop: res2.label,
                      };
                      // this.selectedCrop = res2.label;
                    }
                  });
                  return;
                }
              });
            }

            // if(data?.EstimationComponentDetail && data?.EstimationComponentDetail.length > 0){
            //   data?.EstimationComponentDetail.map(val => ({
            //     ...val,
            //     totalCost: val.Price*val.Quantity
            //   }))
            //   let componentTotal = 0;
            //   data?.EstimationComponentDetail.forEach(val => {
            //     componentTotal += val.Price*val.Quantity;
            //   })

            //   data = {
            //     ...data,
            //     componentTotal: componentTotal
            //   }
            // }

            if(data?.AppID){
              this.miEstimationDataArray.push(data);
            }
          },
          error: () => {
            // this.loader.close();
            // this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data Error : Vendor Consent Form Not Loaded' });
          },
        });
    }
  }

  getSanctionLetterData(appId, progID) {
    this.challanMIService
      .getSanctionLetterData(appId, progID)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.sanctionLetterDataArray.push(res);
        },
        error: (err) => {
          // console.log('error', err);
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: err,
          // });
        },
      });
  }

  getMIBOQData(appId, vendorId, programId) {
    if (appId && vendorId && programId) {
      this.deptDashBoardService
        .getVendorMIBOQ(this.appId, vendorId, programId)
        .pipe(first())
        .subscribe({
          next: (data) => {
            if (data?.BoqStatus == 1) {
              this.miBOQDataArray.push(data);
            }

            // if (data?.BoqStatus == 1) {
            //   this.appDetails = data;
            // }
            // // this.vendorApplicationDetails = data;
            // this.miBOQDataArray.push(data);
          },
          error: () => {
            // this.loader.close();
            // this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data Error : Vendor Consent Form Not Loaded' });
          },
        });
    }
  }

  getPhysicalSurveyData(autoId, userId) {
    if (autoId && userId) {
      this.jeService
        .getApplicationDataForPhysicalVerification(autoId, userId)
        .pipe(first())
        .subscribe({
          next: (data) => {
            this.calculatedSubsidyDataForMIPhys = data;
          },
          error: () => {
            // this.loader.close();
            // this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data Error : Vendor Consent Form Not Loaded' });
          },
          complete: () => {
            // this.loader.start();
            this.jeService
              .getApplicationDataForPhysicalVerification_CalculatedSubsidy(
                autoId,
                userId
              )
              .pipe(first())
              .subscribe({
                next: (data) => {
                  if (data['PhySurveyStatus'] == 1) {
                    this.physicalSurveyDetails = data;

                    if (
                      this.physicalSurveyDetails.listGPSCoordinatesJE.length > 0
                    ) {
                      this.showMapJE = true;
                      let locationArray = [];
                      this.physicalSurveyDetails.listGPSCoordinatesJE.forEach(
                        (e) => {
                          locationArray.push({
                            lat: e.Latitude,
                            lng: e.Longitude,
                          });
                        }
                      );
                      this.optionsJE = {
                        center: {
                          lat: locationArray[0].lat,
                          lng: locationArray[0].lng,
                        },
                        zoom: 17,
                        mapTypeId: google.maps.MapTypeId.SATELLITE,
                      };
                      let pointLocations = [];
                      locationArray.forEach((e) => {
                        pointLocations.push(
                          new google.maps.Marker({
                            position: { lat: e.lat, lng: e.lng },
                          })
                        );
                      });
                      this.overlaysJE = [
                        ...pointLocations,
                        new google.maps.Polygon({
                          paths: [...locationArray],
                          strokeOpacity: 0.5,
                          strokeWeight: 1,
                          fillColor: '#1976D2',
                          fillOpacity: 0.35,
                        }),
                      ];

                      this.physicalSurveyDetails = {
                        ...this.physicalSurveyDetails,
                        optionsJE: this.optionsJE,
                        overlaysJE: this.overlaysJE,
                      };
                    } else {
                      this.showMapJE = false;
                    }

                    if (
                      this.physicalSurveyDetails.listGPSCoordinatesXEN.length >
                      0
                    ) {
                      this.showMapXEN = true;
                      let locationArray = [];
                      this.physicalSurveyDetails.listGPSCoordinatesXEN.forEach(
                        (e) => {
                          locationArray.push({
                            lat: e.Latitude,
                            lng: e.Longitude,
                          });
                        }
                      );
                      this.optionsXEN = {
                        center: {
                          lat: locationArray[0].lat,
                          lng: locationArray[0].lng,
                        },
                        zoom: 17,
                        mapTypeId: google.maps.MapTypeId.SATELLITE,
                      };
                      let pointLocations = [];
                      locationArray.forEach((e) => {
                        pointLocations.push(
                          new google.maps.Marker({
                            position: { lat: e.lat, lng: e.lng },
                          })
                        );
                      });
                      this.overlaysXEN = [
                        ...pointLocations,
                        new google.maps.Polygon({
                          paths: [...locationArray],
                          strokeOpacity: 0.5,
                          strokeWeight: 1,
                          fillColor: '#1976D2',
                          fillOpacity: 0.35,
                        }),
                      ];

                      this.physicalSurveyDetails = {
                        ...this.physicalSurveyDetails,
                        optionsXEN: this.optionsXEN,
                        overlaysXEN: this.overlaysXEN,
                      };
                    } else {
                      this.showMapXEN = false;
                    }

                    if (this.calculatedSubsidyDataForMIPhys) {
                      this.physicalSurveyDetails = {
                        ...this.physicalSurveyDetails,
                        calculatedSubsidyDataForMIPhys:
                          this.calculatedSubsidyDataForMIPhys,
                      };
                      this.physicalSurveyDetailsArray.push(
                        this.physicalSurveyDetails
                      );
                    } else {
                      this.physicalSurveyDetailsArray.push(
                        this.physicalSurveyDetails
                      );
                    }
                  }
                },
                error: () => {
                  // this.loader.close();
                  // this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data Error : Form Not Loaded' });
                },
              });
          },
        });
    }
  }

  getCalculatedSubsidyDataForMIPhys(autoId, userId) {
    this.jeService
      .getApplicationDataForPhysicalVerification(autoId, userId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.calculatedSubsidyDataForMIPhys = data;
        },
        error: () => {
          // this.loader.close();
          // this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data Error : Vendor Consent Form Not Loaded' });
        },
      });
  }
}

// import { Component, OnInit } from '@angular/core';
// import { ActivatedRoute, Router } from '@angular/router';
// import { MessageService } from 'primeng/api';
// import { ApplicationDetailsModel } from 'src/app/models/farmers-application.model';
// import { DashboardService } from 'src/app/services/dashboard.service';
// import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
// import { first } from 'rxjs';
// import { CryptoJsService } from 'src/app/services/crypto-js.service';
// import { TranslateService } from '@ngx-translate/core';
// import { ActivityRecordService } from 'src/app/services/activity-record.service';
// import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
// import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';

// @Component({
//   selector: 'app-vendor-consent-form',
//   templateUrl: './vendor-consent-form.component.html',
//   styleUrls: ['./vendor-consent-form.component.scss']
// })
// export class VendorConsentFormComponent implements OnInit {
//   vendorApplicationDetails: any;
//   preEstimateDetails: any;
//   vendorId: any;
//   programId: any;
//   public appId: any;
//   statusCode: any;
//   isActionSectionEnabled: boolean;
//   userID: any;
//   appID: any;
//   public viewWorkFlowAllStatus: boolean = false;
//   public cropType: any;
//   public selectedCropType: any;
//   public selectedCrop: any;

//   public physicalSurveyDetails: any;

//   optionsPreEstimate: any;
//   overlaysPreEstimate: any[];
//   showMapPreEstimate: any;

//   optionsJE: any;
//   overlaysJE: any[];
//   showMapJE: any;

//   optionsXEN: any;
//   overlaysXEN: any[];
//   showMapXEN: any;

//   miSurveyMapoptions: any;
//   miSurveyoverlays: any[];

//   constructor(
//     private route: ActivatedRoute,
//     private translateService: TranslateService,
//     private _dashboardService: DashboardService,
//     private router: Router,
//     private deptDashBoardService: DepartmentDashboardService,
//     private cryptoJsService: CryptoJsService,
//     private messageService: MessageService,
//     private activityRecordService: ActivityRecordService,
//     private loader: AppLoaderService,
//     private vendorService: VendorDashboardService,
//     ) { }

//   applicationDetails: ApplicationDetailsModel = new ApplicationDetailsModel();
//   // farmerDetails: any;
//   ngOnInit() {
//     this.getCropMaster();
//     this.optionsJE = {
//       center: { lat: 36.890257, lng: 30.707417 },
//       zoom: 12
//     };
//     let sessionToken = sessionStorage.getItem('token');
//     let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
//     this.userID = JSON.parse(payload)?.sub;
//     // this.farmerDetails = JSON.parse(sessionStorage.getItem('farmerDetails'));
//     // console.log(this.farmerDetails);

//     let appId = this.route.snapshot.paramMap.get('appId');
//     this.vendorId=this.route.snapshot.paramMap.get('vendorId');
//    this.programId=this.route.snapshot.paramMap.get('programId');
//    this.appID=this.route.snapshot.paramMap.get('appId');

//     if (appId) {
//       // this.getApplicationDetails('MICADAN20220000003');
//       this.getApplicationDetails(appId);
//     }
//     this.route.queryParams
//     .subscribe(params => {
//       this.statusCode = this.cryptoJsService.DecryptData(params.statusCode);
//       if (params.statusCode == this.cryptoJsService.Encrypt('C') || params.statusCode == this.cryptoJsService.Encrypt('P')) {
//         this.isActionSectionEnabled = true;
//       } else {
//         this.isActionSectionEnabled = false;
//       }
//     }
//     );
//     if(appId && this.vendorId && this.programId){
//       this.loader.start();
//       this.deptDashBoardService.getVendorMIEstimation(appId, this.vendorId, this.programId)
//       .pipe(first())
//       .subscribe({
//         next: (data) => {
//           this.activityRecordService.activityRecord(this.userID, 'View Application', this.appID, new Date(), 'Success');

//           this.vendorApplicationDetails = data;
//           this.loader.close();
//         },
//         error: (err) => {
//           this.loader.close();
//           this.activityRecordService.activityRecord(this.userID, 'View Application', this.appID, new Date(), err);

//           this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data Error : Vendor Consent Form Not Loaded' });
//         }
//       });
//     }

//     // if(this.autoId && this.userId){
//     //   this.deptDashBoardService.getApplicationDataForPhysicalVer(this.autoId, this.userId)
//     //     .pipe(first())
//     //     .subscribe({
//     //       next: (res) => {
//     //         this.physicalSurveyDetails = res;

//     //         if( this.physicalSurveyDetails.listGPSCoordinatesJE.length>0){
//     //           this.showMapJE = true;
//     //           let locationArray = []
//     //           this.physicalSurveyDetails.listGPSCoordinatesJE.forEach(e => {
//     //           locationArray.push({ lat: e.Latitude, lng: e.Longitude })
//     //         })
//     //         this.optionsJE = {
//     //           center: { lat: locationArray[0].lat, lng: locationArray[0].lng },
//     //           zoom: 12,
//     //           mapTypeId: google.maps.MapTypeId.SATELLITE
//     //         };
//     //         let pointLocations = [];
//     //         locationArray.forEach(e => { pointLocations.push(new google.maps.Marker({ position: { lat: e.lat, lng: e.lng } })) });
//     //         this.overlaysJE = [
//     //           ...pointLocations,
//     //           new google.maps.Polygon({
//     //             paths: [...locationArray], strokeOpacity: 0.5, strokeWeight: 1, fillColor: '#1976D2', fillOpacity: 0.35
//     //           }),
//     //         ];
//     //         }
//     //         else{
//     //           this.showMapJE = false;
//     //         }

//     //       },
//     //       error: () => {

//     //       }
//     //     })
//     // }

//     if (this.appId && this.programId) {
//       this.deptDashBoardService.getApplicationDataOfPreEstimation(this.appId, this.programId)
//         .pipe(first())
//         .subscribe({
//           next: (data) => {
//             this.preEstimateDetails = data;

//             if(this.preEstimateDetails.CropTypeID && this.preEstimateDetails.CropId){
//               this.cropType.forEach((res) => {
//                 if (res.data === data.CropTypeID) {
//                   this.selectedCropType = res.label;
//                   let crop = res.children;
//                   crop.forEach((res2) => {
//                     if(res2.data === data.CropId){
//                       this.selectedCrop = res2.label;
//                     }
//                   })
//                   return;
//                 }
//               });
//             }

//             if( this.preEstimateDetails.listGPSCoordinates.length>0){
//               this.showMapPreEstimate = true;
//               let locationArray = []
//             this.preEstimateDetails.listGPSCoordinates.forEach(e => {
//               locationArray.push({ lat: e.Latitude, lng: e.Longitude })
//             })
//             this.optionsPreEstimate = {
//               center: { lat: locationArray[0].lat, lng: locationArray[0].lng },
//               zoom: 12,
//               mapTypeId: google.maps.MapTypeId.SATELLITE
//             };
//             let pointLocations = [];
//             locationArray.forEach(e => { pointLocations.push(new google.maps.Marker({ position: { lat: e.lat, lng: e.lng } })) });
//             this.overlaysPreEstimate = [
//               ...pointLocations,
//               new google.maps.Polygon({
//                 paths: [...locationArray], strokeOpacity: 0.5, strokeWeight: 1, fillColor: '#1976D2', fillOpacity: 0.35
//               }),
//             ];
//             }
//             else{
//               this.showMapPreEstimate = false;
//             }

//           },
//           error: () => {
//             // this.loader.close();
//             // this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data Error : Vendor Consent Form Not Loaded' });
//           }
//         });
//     }
//   }

//   getCropMaster() {
//     // this.loader.start();
//     this.vendorService
//       .getCropMaster()
//       .pipe(first())
//       .subscribe({
//         next: (res) => {
//           console.log('Crop Master', res);
//           this.cropType = res;
//           // this.loader.close();
//         },
//         error: () => {
//           // this.loader.close();
//           this.messageService.add({
//             severity: 'error',
//             summary: 'Error Message',
//             detail: 'Data error! Crop Master not loaded.',
//           });
//         },
//       });
//   }

//   workFlowAllStatus() {
//     this.viewWorkFlowAllStatus = true;
//   }

//   onClickApp() {
//     let statusCodeEncrypted = this.cryptoJsService.Encrypt(this.statusCode);
//     const link = this.router.serializeUrl(this.router.createUrlTree(['vendor', 'print', this.appId, this.vendorId,this.programId], { queryParams: { statusCode: statusCodeEncrypted } }));
//     window.open(link, '_blank');
//   }
//   getApplicationDetails(appId) {
//     this.loader.start();
//     this._dashboardService.getApplicationByAppId(appId)
//     .pipe(first())
//     .subscribe({
//       next: (res) => {
//         console.log(res);
//         this.applicationDetails = res;
//         this.loader.close();
//       },
//       error: (err) => {
//         this.loader.close();
//       },
//     })

//     // this._dashboardService.getApplicationByAppId(appId).subscribe((res) => {
//     //   if (res) {
//     //     console.log(res);
//     //     this.applicationDetails = res
//     //   }

//     // })

//   }

// }
